import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
import Flag from "@/modules/vue/components/Flag.vue";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Team',
  props: {
    team: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Flag, {
        country: __props.team.country,
        class: "mr-2"
      }, null, 8, ["country"]), _createVNode(EntityLink, {
        entity: __props.team
      }, null, 8, ["entity"])]);
    };
  }
});